// import React from 'react';

// const services = [
//   { title: 'Packers & Movers', desc: 'Reliable home shifting solutions' },
//   { title: 'Car Transportation', desc: 'Safe car shifting service' },
//   { title: 'Warehouse Services', desc: 'Secure storage facilities' },
//   { title: 'Truck Rental', desc: 'Affordable truck booking' },
// ];

// const Services = () => {
//   return (
//     <section className="py-12 px-6 bg-white text-center">
//       <h2 className="text-3xl text-primary font-semibold mb-8">Our Services</h2>
//       <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
//         {services.map((service, index) => (
//           <div key={index} className="border p-4 rounded shadow hover:shadow-lg transition">
//             <h3 className="text-xl font-bold text-dark mb-2">{service.title}</h3>
//             <p className="text-gray-600">{service.desc}</p>
//           </div>
//         ))}
//       </div>
//     </section>
//   );
// };

// export default Services;

import React from 'react';

const services = [
  { icon: '🚛', title: 'Packers and Movers' },
  { icon: '🚗', title: 'Car Transportation' },
  { icon: '🚚', title: 'Hire Truck Tempo' },
  { icon: '📦', title: 'Cargo' },
  { icon: '🚛', title: 'Transport' },
  { icon: '🏬', title: 'Warehouse' },
  { icon: '🌍', title: 'International Movers' },
  { icon: '🐶', title: 'Pet Relocation' },
  { icon: '🏍️', title: 'Bike Ride' },
  { icon: '📦', title: 'Package Delivery' },
  { icon: '✈️', title: 'Freight Forwarders' },
];

const Services = () => {
  return (
    <section className="py-16 px-8 bg-white">
      <h2 className="text-4xl text-primary font-bold text-center mb-12">Explore Our Core Services</h2>
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
        {services.map((service, index) => (
          <div key={index} className="flex flex-col items-center justify-center bg-light p-6 rounded-xl shadow hover:shadow-lg transition">
            <div className="text-5xl mb-3">{service.icon}</div>
            <h3 className="text-primary font-semibold text-center text-lg">{service.title}</h3>
          </div>
        ))}
      </div>
      <div className="mt-16 bg-primary text-white p-10 rounded-xl text-left max-w-5xl mx-auto shadow-lg">
        <h3 className="text-3xl font-extrabold mb-4">You RELY on Trust, We PROVIDE the TRUST</h3>
        <p className="mb-3 leading-relaxed">
          Tiranga Express connects you with India’s best logistics providers backed by third-party verification.
          Whether you're relocating a home or business, we ensure safe, fast and dependable services.
        </p>
        <p className="leading-relaxed">
          Our verified network covers urban, rural, and industrial zones — ensuring unmatched service for all shifting needs.
        </p>
        <button className="bg-secondary text-white mt-6 px-6 py-3 rounded hover:bg-accent transition text-lg font-semibold">GET QUOTES</button>
      </div>
    </section>
  );
};

export default Services;
